import EDC from '@/components/games/shared/globals';
/**
 *
 */
EDC.Games.AutoContinue.Scenes.Preloader = function () {};
/**
 *
 */
EDC.Games.AutoContinue.Scenes.Preloader.prototype.create = function () {
  this.load.on('complete', this.onLoadImagesComplete, this);
  this.load.setPath('https://s3.amazonaws.com/images.growmindgrow/phaser-assets/images/views/ContinueScreen/');
  this.load.image('background', 'Background.jpg');
  this.load.image('continue-frame', 'Frame.png');
  this.load.image('continue-frame-hover', 'Frame_Hover.png');
  this.load.image('continue-arr', 'Arrow.png');
  this.load.image('continue-text', 'Continue.png');
  this.load.image('or-sign', 'Or.png');
  this.load.image('btn-frame', 'btnFrame.png');
  this.load.image('btn-frame-hover', 'btnFrame_Hover.png');
  this.load.image('swith-btn-text', 'Switch_Text.png');
  this.load.image('swith-btn-icon', 'Switch_Icon.png');
  this.load.image('logo', '../../OrbUp_Logo.png');

  this.load.setPath();
  this.load.start();
};
/**
 *
 */
// eslint-disable-next-line max-len
EDC.Games.AutoContinue.Scenes.Preloader.prototype.onLoadImagesComplete = function () {
  this.load.off(this.onLoadImagesComplete, this);
  this.scene.start('AutoContinue-Main');
};

export default EDC.Games.AutoContinue.Scenes.Preloader;
